module.exports = __webpack_public_path__ + "img/suone_3.b66702e3.jpg";